import { gql } from '@apollo/client'

export const RESULTS_QUERY = gql`
  query results($sortBy: ResultSort, $filter: ResultFilter, $limit: Int) {
    results(sortBy: $sortBy, filter: $filter, limit: $limit) {
      collection {
        id
        resultType
        closingMailContent
        title
        systemValue
        processingTypeId
        parentResultId
        requiresChildSelection
        availableForActionType
        helpText
        processingResult
        closingInfoEmailEnabled
        archived
        parentResult {
          id
          title
          closingMailContent
          parentResultId
          requiresChildSelection
          parentResult {
            id
            title
            parentResultId
            requiresChildSelection
          }
        }
        childResults {
          id
          resultType
          closingMailContent
          closingInfoEmailEnabled
          title
          systemValue
          parentResultId
          requiresChildSelection
          availableForActionType
          helpText
          closingInfoEmailEnabled
          processingResult
          archived
          childResults {
            id
            resultType
            closingMailContent
            closingInfoEmailEnabled
            title
            systemValue
            parentResultId
            requiresChildSelection
            availableForActionType
            helpText
            processingResult
            archived
          }
        }
        __typename
      }
    }
  }
`
